import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "fb-px",
  "use": "fb-px-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"fb-px\"><path d=\"M14.5.866a3 3 0 013 0l10.856 6.268a3 3 0 011.5 2.598v12.536a3 3 0 01-1.5 2.598L17.5 31.134a3 3 0 01-3 0L3.644 24.866a3 3 0 01-1.5-2.598V9.732a3 3 0 011.5-2.598L14.5.866z\" fill=\"#3C5A99\" /><path d=\"M22 12l5 4.235L22 20M10 12l-5 4.235L10 20\" stroke=\"#fff\" stroke-width=\"1.6\" /><path d=\"M19 8l-5 14\" stroke=\"#fff\" stroke-width=\"2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol